import type { Delivery } from '@citibox-panel/api-client';
import {
  deliveryClipboardHeaders,
  deliveryClipboardValues,
  type ClipboardRecipient,
} from './deliveryClipboardCells';

// Escape the three text-content metacharacters so a value carrying &, < or > can never corrupt
// the table markup — & first, so the entities it produces are not double-escaped. No attributes
// are emitted, so " and ' need no escaping. It covers a carrier name and, since this row can
// carry a titular, a «Usuario» name too: a string a third party chose, in markup assembled by
// concatenation.
function escapeHtml(value: string): string {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// The rich (text/html) clipboard flavour for one delivery row: a real <table> with a header row
// and a value row, mirroring the plain TSV. Rich-text targets (Notion, Google Docs, Confluence)
// rebuild a table from this flavour — plain TSV pastes as a table only in Zendesk/spreadsheets,
// not in Notion, which is why manually copying an HTML row works but writeText() alone did not.
// Values come from the shared deliveryClipboardValues, so the two flavours cannot drift.
export function buildDeliveryClipboardHtml(
  delivery: Delivery,
  phone: string,
  recipient?: ClipboardRecipient,
): string {
  const headerCells = deliveryClipboardHeaders(recipient)
    .map((header) => `<th>${escapeHtml(header)}</th>`)
    .join('');
  const valueCells = deliveryClipboardValues(delivery, phone, recipient)
    .map((value) => `<td>${escapeHtml(value)}</td>`)
    .join('');
  return `<table><thead><tr>${headerCells}</tr></thead><tbody><tr>${valueCells}</tr></tbody></table>`;
}
